import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentTask: null,
  tasks: [],
}

export const taskSlice = createSlice({
  name: 'task',
  initialState,
  reducers: {
    setTasks: (state, action) => ({
      ...state,
      tasks: action.payload
    }),
    addTask: (state, action) => ({
      ...state,
      tasks: [
        ...state.tasks,
        action.payload
      ]
    }),
    updateTask: (state, action) => ({
      ...state,
      tasks: state.tasks.map((task) => {
        if (task.id === action.payload.id)
          return { ...task, ...action.payload.data };
        return task;
      }),
    }),
    removeTask: (state, action) => ({
      ...state,
      tasks: state.tasks.filter((task) => {
        return task.id !== action.payload;
      }),
    }),
    setCurrentTask: (state, action) => ({
      ...state,
      currentTask: action.payload
    })
  }

})
export const {
  setTasks,
  addTask,
  updateTask,
  removeTask,
  setCurrentTask,
} = taskSlice.actions


export default taskSlice.reducer